export enum MfaPhoneStatus {
  Verified = "verified",
  Unverified = "unverified",
  MissingPhoneNumber = "missing-phone-number"
}
